import {FC} from "react";
import {Stack, Typography} from "@mui/material";
import {useSSTranslation} from "@/i18n/useSSTranslation";
import {II18nMap} from "@/i18n/en";
const campfireTear1 = "/campfire_lv-1_data.svg";
const campfireTear2 = "/campfire_lv-2_data.svg";
const campfireTear3 = "/campfire_lv-3_data.svg";
const campfireTear4 = "/campfire_lv-4_data.svg";

interface PauseStreakDrawerContent {
	streakDays: number;
	width: string;
	height: string;
}

const PauseStreakDrawerContent: FC<PauseStreakDrawerContent> = ({
	streakDays,
	width,
	height
}) => {
	const {t} = useSSTranslation();
	let image = campfireTear1;

	if (streakDays > 0){
		image = campfireTear2;
		if (streakDays > 1){
			image = campfireTear3;
		}

		if (streakDays > 100){
			image = campfireTear4;
		}
	}

	return (
		<Stack
			sx={{
				justifyContent: "center",
				alignItems: "center",
			}}
		>
			<img
				src={image}
				alt={"Campfire animated image"}
				width={width}
				height={height}
			/>

		</Stack>
	)
}

export default PauseStreakDrawerContent;